module.exports = "<div class=\"countUpFW\" data-startval=\"0\" data-endval=\"1000\" data-decimals=\"\" data-duration=\"3\" data-delay=\"1\" >\n  <span class=\"countUpFW__num\"></span>\n  <span class=\"countUpFW__unit\">€</span>\n  <div class=\"countUpFW__label\">Lorem ipsum</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/countUpFW/sample.html
// module id = 67
// module chunks = 0